import { render, staticRenderFns } from "./ConsultaClassificacaoSemed.vue?vue&type=template&id=a4527418&"
import script from "./ConsultaClassificacaoSemed.vue?vue&type=script&lang=js&"
export * from "./ConsultaClassificacaoSemed.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaClassificacaoSemed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports